import { useContext } from "react"
import { Router, Redirect } from "@reach/router"
import { HardRefresh } from "source/shared/routingUtils"
import {
  useRegistrationsProxyPaths,
  useRegistrationsSetting,
} from "source/registrations/features_and_settings"
import { ServerRenderedProps } from "source/shared/ServerRenderedProps"
import { WideLayout } from "source/shared/Layout"
import Events, {
  UnknownFilterEvents,
  FilteredEvents,
} from "source/registrations/events"
import Event from "source/registrations/event"
import Reservations from "source/registrations/reservations"
import { default as Registration } from "source/registrations/registrations"

export function Registrations() {
  if (!useRegistrationsSetting("church_center_web")) {
    const { paths } = useContext(ServerRenderedProps)
    window.location = paths.missing_organization
  }

  if (!useRegistrationsSetting("church_center_web_registrations")) {
    return <Redirect to={"/home"} />
  }

  const proxiedPaths = useRegistrationsProxyPaths()

  return (
    <WideLayout>
      <Router basepath="/registrations">
        {proxiedPaths.map((path) => (
          <HardRefresh key={path} path={path} />
        ))}
        <HardRefresh path="/profile" exact />

        <UnknownFilterEvents path="/signups/:filter/:filterId" />
        <FilteredEvents path="/signups/campus/:campusId/category/:categoryId" />
        <Event path="/signups/:eventId" />
        <Events path="/signups" exact default />

        <UnknownFilterEvents path="/events/:filter/:filterId" />
        <FilteredEvents path="/events/campus/:campusId/category/:categoryId" />
        <Event path="/events/:eventId" />
        <Events path="/events" exact default />

        <Reservations path="/:eventSignupPath/:eventId/reservations/*" />
        <Registration path="/registrations/:registrationId/*" />
      </Router>
    </WideLayout>
  )
}
